import { useDispatch, useSelector } from "react-redux";
import {
  IsLoading,
  loadTimeEntriesInfo,
  SelectCostCentersApprovalTimeComplete,
  SelectManagersApprovalTime,
  SelectOrderedBy,
  setLoading,
} from "../redux/reducers/approvalTime.reducer";
import { useCallback, useEffect } from "react";
import { TimesheetsService } from "../services/timesheets";
import {
  hasTimeViewerAccess,
  preparedFiltersToApprove,
} from "../utils/timesUtils";
import { selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";
import {
  hasSuperTimeAdminAccess,
  isDeliveryTimeAdminChecker,
  isSupervisor,
  isSupervisorOrProjectOwner,
} from "../../SharedModule/utils/accessUtils";

export const useApprovalTime = (
  filters: any,
  isInfoApprovalLoaded: boolean,
  projectFilterByParam: any,
  endDateFilterByParam: any,
  rolesLoaded: any,
  projectsApprovalTimeFiltered: any
) => {
  const dispatch = useDispatch();

  const isLoading = useSelector(IsLoading);
  const managersApprovalTime = useSelector(SelectManagersApprovalTime);
  const costCentersApprovalTimeComplete = useSelector(
    SelectCostCentersApprovalTimeComplete
  );
  const { userList } = useSelector(SelectOrderedBy);

  const { userRolesList } = useSelector(selectUserRoles);

  const isSuperTimeAdmin = hasSuperTimeAdminAccess(userRolesList);
  const hasSupervisorRole = isSupervisor(userRolesList);
  const isSupervisorOrPO = isSupervisorOrProjectOwner(userRolesList);
  const isDeliveryTimeAdmin = isDeliveryTimeAdminChecker(userRolesList);

  const { activeUserId } = useSelector(selectUserRoles);

  // ASUITE11-2614: Approve Time from the Project (link to The Hub) - FE
  // send params values to calculate in first load
  let filtersUpdated =
    projectFilterByParam && !filters.project
      ? {
          ...filters,
          project: projectFilterByParam,
          endDate: endDateFilterByParam
            ? endDateFilterByParam
            : filters.endDate,
        }
      : {
          ...filters,
          endDate: endDateFilterByParam
            ? endDateFilterByParam
            : filters.endDate,
        };

  let filtersForRequest;
  if (isInfoApprovalLoaded && rolesLoaded) {
    filtersForRequest = preparedFiltersToApprove(
      filtersUpdated,
      isSuperTimeAdmin,
      isSupervisorOrPO,
      managersApprovalTime,
      costCentersApprovalTimeComplete,
      projectsApprovalTimeFiltered
    );
  }

  const loadTimeEntriesToApprove = useCallback(async () => {
    dispatch(setLoading(true));
    if (isInfoApprovalLoaded && rolesLoaded) {
      const results = await TimesheetsService.getTimeEntriesToApproveByUsers(
        filtersForRequest
      );
      dispatch(loadTimeEntriesInfo(results.data));
    }
  }, [dispatch, filters, isInfoApprovalLoaded, rolesLoaded]);

  useEffect(() => {
    loadTimeEntriesToApprove();
  }, [loadTimeEntriesToApprove]);

  return {
    isLoading,
    activeUserId,
    userList,
    hasSupervisorRole,
    isSupervisorOrPO,
    isSuperTimeAdmin,
    isDeliveryTimeAdmin,
  };
};
